import { httpDelete, httpGet, httpPost } from "../../../api/connection";
import {
  GoogleGetAuthUrlFn,
  GoogleGetIntegrationFn,
  GoogleGetUsersFn,
  GoogleSaveOAuth2CredentialsFn,
  GoogleSaveServiceAccountCredentialsFn,
} from "./Google.types";

const getIntegration: GoogleGetIntegrationFn = async (query) => {
  return httpGet("/integrations/google", query);
};

const getAuthUrl: GoogleGetAuthUrlFn = async () => {
  return httpGet("/integrations/google/oauth2/url");
};

const remove = async (values: { integration_id: number }) => {
  return httpDelete(`/integrations/google/${values.integration_id}`);
};

const saveServiceAccountCredentials: GoogleSaveServiceAccountCredentialsFn =
  async (values) => {
    return httpPost("/integrations/google/service-account-credentials", values);
  };

const saveOAuth2Credentials: GoogleSaveOAuth2CredentialsFn = async (values) => {
  return httpPost("/integrations/google/oauth2", values);
};

const getUsers: GoogleGetUsersFn = async (query) => {
  return httpGet("/integrations/google/users", query);
};

export const GoogleAPI = {
  getIntegration,
  getAuthUrl,
  getUsers,
  delete: remove,
  saveServiceAccountCredentials,
  saveOAuth2Credentials,
};
